import { object, string as yupString } from 'yup'

export const schemaForRegularLogin = object({
  password: yupString().required('Password is required'),
  email: yupString().email().required(),
})
